import { useDispatch, useSelector } from 'react-redux';
import { isDefined, isJSON } from 'class-validator';

import { MMUStatusChanged, surferAddressChanged, surferStateChanged } from 'src/app/redux/actions/socket.action';

import { EMesajAltTipi, EMesajTipi, ReceivedMessageType } from 'src/types/components/socket.type';
import { EMMUConnectionStatus } from 'src/types/components/mmu.type';
import { reduxRootTypes } from 'src/types';

import { mmuHelper } from '../helpers';
import { eventActions } from '../redux/actions';
import { GameState } from 'src/enums/game-state.enum';
import { base64ToArrayBuffer, blobToJSON } from '../helpers/quads.helper';

type Props = {
  openNotification: (title: string, context: string, isError: boolean) => void;
};

export const useMMUSocket = ({ openNotification }: Props) => {
  const dispatch = useDispatch();

  const { MMUStatus, isSurferOn, surferAddress } = useSelector(
    (state: reduxRootTypes.RootStateType) => state.socketState,
  );

  const MMUListenerHandler = () => {
    if (MMUStatus === EMMUConnectionStatus.CONNECTED) {
      mmuHelper.listenSocket(async (event: any) => {
        try {
          const { data } = event;
          const parsedData = JSON.parse(data);

          if (parsedData.zipliMi && parsedData.icerik) {
            console.time('zip');

            const arrayBuffer = base64ToArrayBuffer(parsedData.icerik);
            parsedData.icerik = await blobToJSON(new Blob([arrayBuffer]));

            console.timeEnd('zip');
          }

          if (isJSON(data)) {
            const genericMessage: ReceivedMessageType = parsedData;

            switch (genericMessage.mesajTipi) {
              case EMesajTipi.GENEL:
                switch (genericMessage.mesajAltTipi) {
                  case EMesajAltTipi.BAGLANTI_KABUL:
                    dispatch(MMUStatusChanged(EMMUConnectionStatus.HANDSHAKED));
                    break;

                  default:
                    break;
                }

                break;

              case EMesajTipi.MMU:
                switch (genericMessage.mesajAltTipi) {
                  case EMesajAltTipi.YONLENDIRME:
                    dispatch(surferAddressChanged(genericMessage.icerik));

                    if (isDefined(genericMessage.icerik)) {
                      dispatch(surferStateChanged(true));
                    }
                    break;

                  case EMesajAltTipi.UYGUN_SURFER_BULUNMUYOR:
                    openNotification('Surfer Connection', 'No available Surfer', true);
                    break;

                  default:
                    break;
                }
                break;

              default:
            }
          }
          // else {
          //   dispatch(gameActions.gameStateChanged(GameState.Idle));
          // }
        } catch (error) {
          openNotification('Surfer Connection', 'Failed to read data from surfer', true);
          dispatch(eventActions.eventStateChanged(GameState.Default));
        }
      });
    }
  };

  return {
    MMUListenerHandler,
    openNotification,
  };
};
